/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Edit_PlaceholderInputs */

const es_chat_edit_placeholder = /** @type {(inputs: Chat_Edit_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar mensaje...`)
};

const en_chat_edit_placeholder = /** @type {(inputs: Chat_Edit_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit message...`)
};

/**
* | output |
* | --- |
* | "Edit message..." |
*
* @param {Chat_Edit_PlaceholderInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_edit_placeholder = /** @type {((inputs?: Chat_Edit_PlaceholderInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Edit_PlaceholderInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_edit_placeholder(inputs)
	return en_chat_edit_placeholder(inputs)
});
export { chat_edit_placeholder as "chat.edit.placeholder" }